import EventCategory from ".";

export const eventCategoryRoutes = () => [
  {
    path: "/admin/event-categories",
    component: EventCategory,
    layout: "admin",
    routeType: "admin",
    title: "Events Management",
  },
];
